module.exports = __webpack_public_path__ + "static/media/loader-button.9f99cb75.svg";